import React, {useState, useEffect, useRef} from 'react';
import ProtectedRoute from '../../routes/protected';
import performanceService from '../../services/data/performance.service';
import { useParams, useNavigate } from 'react-router-dom';
import { Toast } from 'primereact/toast';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'
import bootstrap from 'bootstrap/dist/js/bootstrap.bundle'
import FormCreateGoalPlan from '../../components/performance/forms/formCreateGoalPlan';


export default function GoalPlanEdit() {
    
    const { id } = useParams()
    const toast = useRef(null)
    const navigate = useNavigate();
    const [object, setObject] = useState('')
    const modalRef = useRef()

    useEffect(() => {
        getObject()
    }, [])

    function getObject() {
        performanceService.getGoalPlan(id).then((response) => {
            setObject(response)
        }).catch((error) => {
            console.log(error.response)
        });
    }

    const hideModal = () => {
        const modalEl = modalRef.current
        const bsModal= bootstrap.Modal.getInstance(modalEl)
        bsModal.hide()
    }

    function deleteItem() {
        performanceService.deleteGoalPlan(id).then(() => {
            
            toast.current.show({ severity: 'success', summary: 'Sucesso', detail: 'Plano de Metas apagado com sucesso', life: 3000 });

            setTimeout(() => {
                hideModal()
                navigate('/goal/plan/')
            }, 3000);
        })
    }

    return (
        <ProtectedRoute>

            <Toast ref={toast} position="top-right" />

            <div className="container-fluid">
                <div className='row flex-nowrap'>
                    <div className='col text-bg-green p-3'>
                        <span className="fs-6 fw-bold ps-5" role='button' onClick={() => navigate('/goal/plan/')}>
                            <FontAwesomeIcon className='' icon={solid('arrow-left')} /> {object.title}
                        </span>
                    </div>
                </div>
                <div className='d-flex-auto my-4 mx-5 pt-3 bg-white contentShadow rounded-top paddingBottom200' style={{minHeight: '500px'}}>
                    <div className='px-3 col-6'>
                        <div className='fs-6 text-default mb-4'>
                            Editar Plano de Metas
                        </div>
                        <FormCreateGoalPlan obj={object} />
                        <hr/>
                        <div className="text-end btnMargin">
                            <button className="btn btn-sm font1em text-danger" data-bs-toggle="modal" data-bs-target="#formDel">Apagar Plano de Metas</button>
                        </div>

                        <div id="formDel" className="modal fade" ref={modalRef}>
                            <div className="modal-dialog">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title">Apagar Plano de Metas</h5>
                                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                    </div>
                                    <div className="modal-body">
                                        <p>
                                            Tem certeza de que deseja apagar este Plano de Metas?
                                        </p>
                                        <button className="btn btn-sm btn-danger btn-rounded px-4"  onClick={deleteItem}>Sim, Apagar</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </ProtectedRoute>
    )
}